module.exports = __webpack_public_path__ + "img/image-maxblagun.fa736fb0.png";